import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config.json";
import CustomLoader from "../Reusable/CustomLoader";

const Cookie = () => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPolicies = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/privacy_policy/`);
        setPolicies(response.data.data || []);
      } catch (error) {
        console.error("Error fetching cookie policies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicies();
  }, []);

  return (
    <section className="section-p">
      <div className="page-width">
        <div className="privacy">
          <h1 className="legal-title text-jost-sb-50-wt">COOKIE POLICY</h1>
          <div className="legal__box">
            {loading ? (
              <CustomLoader type="spinner-cub" color="#B4C227" size={100} />
            ) : (
              policies.map((policy) => (
                <div key={policy.id}>
                  <h2 className="legal__box-heading text-jost-sb-22-lg">
                    {policy.title}
                  </h2>
                  <div
                    className="legal__box-para text-ops-rg-16"
                    dangerouslySetInnerHTML={{ __html: policy.description }}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cookie;
